import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
const allAreaRepository = RepositoryFactory.get("allArea");

const state = () => ({
  // all_area APIからのレスポンスをそのまま格納
  data: {},
  // all_area APIから取得した市町村情報の一部をリスト形式で格納する
  municipalities: {},
  // all_area APIから取得した地域情報の一部をリスト形式で格納する
  // 地域に紐づく市町村コードが格納されていることに注意
  areas: {},
  // all_area APIから取得した都道府県情報の一部をリスト形式で格納する
  prefectures: {}
});

const getters = {};

const mutations = {
  setAllArea(state, payload) {
    state.data = payload;
  },
  setMunicipalities(state, payload) {
    state.municipalities = payload;
  },
  setAreas(state, payload) {
    state.areas = payload;
  },
  setPrefectures(state, payload) {
    state.prefectures = payload;
  }
};

const actions = {
  // all_area APIを叩き、レスポンスをそれぞれの形式で格納する
  async loadAllArea(context) {
    // APIを叩く
    const list = await allAreaRepository.getAllArea();
    // 200番台（成功時）、レスポンスを変換して格納
    if (list.status < 300) {
      context.commit("setAllArea", list.data);
      context.commit(
        "setMunicipalities",
        AllAreaTranslator.toMunicipalities(list.data)
      );
      context.commit("setAreas", AllAreaTranslator.toAreas(list.data));
      context.commit(
        "setPrefectures",
        AllAreaTranslator.toPrefectures(list.data)
      );
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
